/**
 * The type-to-find box's two decisions, here so they can be tested without a
 * browser (`components/SearchSelect.tsx`).
 *
 * Punch list F191 (Jeremy, 2 Nov 2026): clicking into the box and deleting the
 * name is how people remove somebody, so leaving the box EMPTY after editing
 * it sets "Not set". Until then only the small × did, and deleting the name
 * and saving silently kept the person. Merely clicking in and out changes
 * nothing: the box opens holding the current name, so empty means somebody
 * deleted it.
 */

/** Should leaving the box clear the choice? Only when the text was edited down to nothing. */
export function clearsChoice(edited: boolean, query: string, value: string): boolean {
  return edited && query.trim() === "" && value !== "";
}

/** What to filter the list by: nothing until the person has typed, so the whole list shows first. */
export function searchNeedle(edited: boolean, query: string): string {
  return edited ? query.trim().toLowerCase() : "";
}
